import { styled } from 'styled-components';
import { Input } from '@devotel/design-system';
import { THEME } from '@src/store/layout/layoutSlice';

export const StyledInput = styled(Input)`
  ::placeholder {
    color: ${(props) =>
      props.theme === THEME.DARK ? '#F5F7F94A' : '#191C1E4A'};
  }
`;
